import ReactDOM from 'react-dom';

// third party
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';

// project imports
import * as serviceWorker from 'serviceWorker';
import App from 'App';
import Store from 'store';

// style + assets
import 'assets/scss/style.scss';
import 'App.scss';
// i18n translations
import "translations/i18n";

// ==============================|| REACT DOM RENDER  ||============================== //

ReactDOM.render(
    <HelmetProvider>
        <Provider store={Store}>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </Provider>
    </HelmetProvider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
